import { render, staticRenderFns } from "./GlobalTransactionChip.vue?vue&type=template&id=3a560620"
import script from "./GlobalTransactionChip.vue?vue&type=script&lang=js"
export * from "./GlobalTransactionChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports